export default __webpack_public_path__ + "static/media/irActive.bd39fe4e.svg";